<template>
  <!-- _________________________ SMS CODE _________________________ -->
  <div id="forgot-password-div" class="position-absolute">

    <h1 class="page-title mt-5">
      {{ $t('verificationCodeTitle') }}
    </h1>
    <h2 class="page-subtitle mt-3">
      {{ $t('verificationCodeSubtitle1') }}<strong>{{ phoneNumber }}</strong>{{ $t('verificationCodeSubtitle2') }}
    </h2>

    <form @submit.stop.prevent="handleSmsSubmit" class="mt-4">

      <b-alert :show="ui.showError" variant="danger">
        {{ ui.showErrorMessage }}
      </b-alert>

      <b-form-group
        :label="$t('smsCredential')"
        label-for="code-input"
        class="bold-label mb-4">
        <b-form-input
          id="code-input"
          v-model="form.code.value"
          required
          @keydown="hideMessages">
        </b-form-input>
      </b-form-group>

      <div class="mt-4">
        <b-button type="submit" class="btn-block" variant="primary">
          <span v-if="!isLoading">{{ $t('smsButtonText') }}</span>
          <b-spinner v-else :label="$t('spinner.isLoading')" small></b-spinner>
        </b-button>
      </div>

    </form>

    <div class="mt-4 text-right">
      <b-link v-on:click="showLoginView" class="forgot-password-link">{{ $t('smsBackToLoginText') }}</b-link>
    </div>
  </div>
</template>

<script>

import api from '../../../services/api'

export default {

  name: 'SmsCodeComponent',

  data () {
    return {
      isLoading: false,
      username: '',
      password: '',
      phoneNumber: '',
      form: {
        code: {
          value: null
        }
      },
      ui: {
        showError: false,
        showErrorMessage: this.$i18n.t('internal.server.error')
      }
    }
  },

  emits: ['showLoginView'],

  methods: {

    async handleSmsSubmit () {

      this.isLoading = true

      let loginIn = false
      let formData = new FormData()
      formData.append('code', this.form.code.value.trim())
      formData.append('username', this.username)
      formData.append('password', this.password)

      await api({
        method: 'POST',
        url: `/authentication/checkSmsCode`,
        data: formData
      })
        .then(async (response) => {
          if (response.status === 200) {
            const data = {
              username: this.form.username.value.trim(),
              password: this.form.password.value.trim()
            }

            await this.LogIn(data)

            this.ui.showError = false
            this.goToHome()
          }
        })
        .catch()((error) => {
          this.isLoading = false
          if (error.response.status === 401) {
            this.ui.showErrorMessage = this.$i18n.t('Login.error')
            this.ui.showError = true
          }
          if (error.response.status === 403) {
            this.ui.showErrorMessage = this.$i18n.t(error.response.data.message)
            this.ui.showError = true
          }
        })
    },

    showLoginView () {
      this.$emit('showLoginView')
    },

    hideMessages () {
      this.hideError()
    },

    hideError () {
      this.ui.showError = false
      this.ui.showErrorMessage = null
      this.ui.showValidateAccountError = false
    },

    goToHome () {
      this.$router.push({
        name: '/'
      })
    }

  }

}

</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/auth/components/SmsCodeComponent.vue